import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomeView from "../../view/welcomeView/WelcomeView";
import TrackingView from "../../view/trackingView/TrackingView";
import AdminAccountView from "../../view/adminAccountView/AdminAccountView";
import AdminTrackingView from "../../view/adminTrackingView/AdminTrackingView";
import LoginView from "../../view/loginView/LoginView";
import AppSkeleton from "./../../view/components/skeleton/AppSkeleton";
import React from "react";
import { protectedRoute } from "./ProtectedRoute";
import PostalAreaView from "../../view/siteManager/plazaManagerPostalAreaView/PostalAreaView";
import PlazaManagerTimeZonesView from "../../view/siteManager/plazaManagerTimeZonesView/SiteManagerTimeZonesView";
import { PATHS, ROLES } from "../app-config";

interface IRouterProps {
  logged: boolean;
  currentLang: string;
}

export default function Router(routerProps: IRouterProps) {
  function welcomeView(props: any) {
    return <AppSkeleton component={<WelcomeView {...props} />} />;
  }
  function trackingView(props: any) {
    return <AppSkeleton component={<TrackingView {...props} />} />;
  }
  function adminTrackingView(props: any) {
    return <AppSkeleton component={<AdminTrackingView {...props} />} />;
  }
  function adminAccountView(props: any) {
    return <AppSkeleton component={<AdminAccountView {...props} />} />;
  }
  function plazaPreAppointmentManager(props: any) {
    return <AppSkeleton component={<PostalAreaView {...props} />} />;
  }
  function plazaTimezonesManager(props: any) {
    return <AppSkeleton component={<PlazaManagerTimeZonesView {...props} />} />;
  }
  function loginView(props: any) {
    return <AppSkeleton component={<LoginView {...props} />} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path={PATHS.root} Component={welcomeView} {...routerProps} />
        <Route path={PATHS.tracking} Component={trackingView} />

        <Route
          path={PATHS.adminTracking}
          element={protectedRoute({
            allowedProfiles: [ROLES.ADMIN, ROLES.SUPPORT],
            component: adminTrackingView({}),
          })}
        />

        <Route
          path={PATHS.adminAccount}
          element={protectedRoute({
            allowedProfiles: [ROLES.ADMIN],
            component: adminAccountView({}),
          })}
        />

        <Route
          path={PATHS.postalAreas}
          element={protectedRoute({
            allowedProfiles: [ROLES.TERRITORY_MANAGER],
            component: plazaPreAppointmentManager({}),
          })}
        />

        <Route
          path={PATHS.timeFrames}
          element={protectedRoute({
            allowedProfiles: [ROLES.TERRITORY_MANAGER],
            component: plazaTimezonesManager({}),
          })}
        />

        <Route path={PATHS.login} element={loginView(routerProps)} {...routerProps} />
      </Routes>
    </BrowserRouter>
  );
}
